import { DateTime } from "luxon"

import { parseDateTimeFromApi } from "../../../../../lib/time"

import { MOCK_ID_CARDS } from "./idCardsListMockData"
import type { IdCardListItem } from "./idCardsListTypes"

export enum MerchantIdCardsListQuery {
    ID_CARDS_LIST = "id-cards-list-for-merchant",
}

export type FetchIdCardsListResponse = Readonly<{
    idCards: ReadonlyArray<IdCardListItem>
}>

type FetchIdCardsListParams = Readonly<{
    merchantId: number
    from: string
    to: string
}>

// TODO: call the backend once the ID cards API exists.
export async function fetchIdCardsList({ from, to }: FetchIdCardsListParams): Promise<FetchIdCardsListResponse> {
    const start = DateTime.fromISO(from).startOf("day")
    const end = DateTime.fromISO(to).endOf("day")

    return {
        idCards: MOCK_ID_CARDS.filter((card) => {
            const created = parseDateTimeFromApi(card.created)
            return created >= start && created <= end
        }),
    }
}
